import { Injectable } from '@angular/core';
import { LoginService } from '../../login/login.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {

  constructor(private loginService: LoginService) { }

  Init() {
    return new Promise<void>((resolve) => {
      this.loginService.autoLogin();
      resolve();
    });
  }
}
